import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NavigationProvider, useNavigation } from './contexts/NavigationContext';
import { Login } from './components/Login';
import { Layout } from './components/Layout';
import { AdminDashboard } from './components/dashboards/AdminDashboard';
import { DocenteDashboard } from './components/dashboards/DocenteDashboard';
import { AlumnoDashboard } from './components/dashboards/AlumnoDashboard';
import { CourseTimeline } from './components/courses/CourseTimeline';
import { Library } from './components/library/Library';
import { Chat } from './components/chat/Chat';
import { UsersManagement } from './components/admin/UsersManagement';
import { CoursesManagement } from './components/admin/CoursesManagement';
import { Reports } from './components/admin/Reports';
import { BimEntregasPage } from './components/admin/BimEntregasPage';
import { AlumnosEnRiesgoPage } from './components/admin/AlumnosEnRiesgoPage';
import { TareasPendientesPage } from './components/admin/TareasPendientesPage';
import { TareasResultadosPage } from './components/admin/TareasResultadosPage';
import { ActividadDocentePage } from './components/admin/ActividadDocentePage';
import { CalendarView } from './components/shared/CalendarView';
import { CoursesList } from './components/shared/CoursesList';
import { Profile } from './components/shared/Profile';
import { Grades } from './components/shared/Grades';
import EmailComposer from './components/email/EmailComposer';
import { LinksManagement } from './components/shared/LinksManagement';
import { LinksViewer } from './components/shared/LinksViewer';
import { CorreccionesBim } from './components/CorreccionesBim';
import { Entregables } from './components/entregables/Entregables';
import { Spinner } from './components/ui/Spinner';

function AppContent() {
  const { user, profile, loading } = useAuth();
  const { currentView, selectedCourse } = useNavigation();

  if (loading) {
    return (
      <div className="relative min-h-screen flex flex-col items-center justify-center gap-4 overflow-hidden">
        <div className="orb orb-lime w-[500px] h-[500px] -top-32 -left-32" aria-hidden="true" />
        <div
          className="orb orb-violet w-[400px] h-[400px] -bottom-32 -right-32"
          aria-hidden="true"
        />
        <div className="relative-z flex flex-col items-center gap-4">
          <Spinner size="lg" label="Cargando sesión" />
          <p className="text-sm text-white/60 font-medium tracking-wide">Cargando Intranet Cubus…</p>
        </div>
      </div>
    );
  }

  if (!user || !profile) {
    return <Login />;
  }

  const renderContent = () => {
    if (currentView === 'profile') {
      return <Profile />;
    }

    if (selectedCourse) {
      return <CourseTimeline courseId={selectedCourse.id} courseName={selectedCourse.name} />;
    }

    if (profile?.role === 'admin') {
      switch (currentView) {
        case 'users':
          return <UsersManagement />;
        case 'courses':
          return <CoursesManagement />;
        case 'library':
          return <Library />;
        case 'calendar':
          return <CalendarView />;
        case 'reports':
          return <Reports />;
        case 'emails':
          return <EmailComposer />;
        case 'links':
          return <LinksManagement />;
        case 'bim-entregas':
          return <BimEntregasPage />;
        case 'alumnos-riesgo':
          return <AlumnosEnRiesgoPage />;
        case 'tareas-pendientes':
          return <TareasPendientesPage />;
        case 'tareas-resultados':
          return <TareasResultadosPage />;
        case 'actividad-docente':
          return <ActividadDocentePage />;
        case 'entregables':
          return <Entregables />;
        default:
          return <AdminDashboard />;
      }
    } else if (profile?.role === 'docente') {
      switch (currentView) {
        case 'courses':
          return <CoursesList />;
        case 'library':
          return <Library />;
        case 'calendar':
          return <CalendarView />;
        case 'chat':
          return <Chat />;
        case 'links':
          return <LinksManagement />;
        case 'bim-dashboard':
          return <CorreccionesBim />;
        case 'entregables':
          return <Entregables />;
        case 'tareas-resultados':
          return <TareasResultadosPage />;
        default:
          return <DocenteDashboard />;
      }
    } else {
      switch (currentView) {
        case 'courses':
          return <CoursesList />;
        case 'library':
          return <Library />;
        case 'calendar':
          return <CalendarView />;
        case 'chat':
          return <Chat />;
        case 'grades':
          return <Grades />;
        case 'links':
          return <LinksViewer />;
        case 'bim-dashboard':
          return <CorreccionesBim />;
        case 'entregables':
          return <Entregables />;
        default:
          return <AlumnoDashboard />;
      }
    }
  };

  return (
    <Layout>
      {renderContent()}
    </Layout>
  );
}

function AppWrapper() {
  return (
    <AuthProvider>
      <AppWithNavigation />
    </AuthProvider>
  );
}

function AppWithNavigation() {
  const { user } = useAuth();

  return (
    <NavigationProvider userId={user?.id}>
      <AppContent />
    </NavigationProvider>
  );
}

function App() {
  return <AppWrapper />;
}

export default App;
